// The card's conversations come from the same month-long window.
export const FORECAST_WINDOW_DAYS = 30

export function formatShare(share: number): string {
	return `${Math.round(share * 1000) / 10}%`
}

// The history chart under the forecast: about three months of weekly bars.
export const CHART_WINDOW_DAYS = 84

/** Start of the window, at midnight, so the query input stays stable all day. */
export function forecastRange(
	now: Date,
	days: number = FORECAST_WINDOW_DAYS,
): { startDate: Date; endDate: Date } {
	const startDate = new Date(now)
	startDate.setHours(0, 0, 0, 0)
	startDate.setDate(startDate.getDate() - days)
	const endDate = new Date(now)
	endDate.setHours(23, 59, 59, 999)
	return { startDate, endDate }
}
